import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2050_154"
      maskUnits="userSpaceOnUse"
      x="0.532227"
      y="0.280273"
      width="16"
      height="24"
      fill="black"
    >
      <rect fill="white" x="0.532227" y="0.280273" width="16" height="24" />
      <path d="M8.53246 1.85361C7.33358 1.85361 4.21585 0.340048 2.41505 2.23135C0.971985 3.74708 1.50498 7.39205 2.53941 9.84474C2.92417 10.7574 2.94845 11.6258 2.93223 12.6105C2.85654 17.2901 1.27113 23.2781 2.40784 23.2803C3.54454 23.2824 5.03269 11.5203 8.53246 11.4003C12.0322 11.2803 11.5322 15.8003 12.0322 18.0003C12.5322 20.2003 13.216 23.2803 13.9078 23.2803C14.5997 23.2803 14.525 20.2003 14.525 19.3203C14.525 18.4403 14.1752 14.7041 14.2241 12.6105C14.2471 11.6258 14.1403 10.757 14.525 9.84474C15.5595 7.39161 16.0925 3.74665 14.6494 2.23135C12.8486 0.340048 9.73134 1.85361 8.53246 1.85361Z" />
    </mask>
    <path
      d="M8.53246 1.85361C7.33358 1.85361 4.21585 0.340048 2.41505 2.23135C0.971985 3.74708 1.50498 7.39205 2.53941 9.84474C2.92417 10.7574 2.94845 11.6258 2.93223 12.6105C2.85654 17.2901 1.27113 23.2781 2.40784 23.2803C3.54454 23.2824 5.03269 11.5203 8.53246 11.4003C12.0322 11.2803 11.5322 15.8003 12.0322 18.0003C12.5322 20.2003 13.216 23.2803 13.9078 23.2803C14.5997 23.2803 14.525 20.2003 14.525 19.3203C14.525 18.4403 14.1752 14.7041 14.2241 12.6105C14.2471 11.6258 14.1403 10.757 14.525 9.84474C15.5595 7.39161 16.0925 3.74665 14.6494 2.23135C12.8486 0.340048 9.73134 1.85361 8.53246 1.85361Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.53246 1.85361C7.33358 1.85361 4.21585 0.340048 2.41505 2.23135C0.971985 3.74708 1.50498 7.39205 2.53941 9.84474C2.92417 10.7574 2.94845 11.6258 2.93223 12.6105C2.85654 17.2901 1.27113 23.2781 2.40784 23.2803C3.54454 23.2824 5.03269 11.5203 8.53246 11.4003C12.0322 11.2803 11.5322 15.8003 12.0322 18.0003C12.5322 20.2003 13.216 23.2803 13.9078 23.2803C14.5997 23.2803 14.525 20.2003 14.525 19.3203C14.525 18.4403 14.1752 14.7041 14.2241 12.6105C14.2471 11.6258 14.1403 10.757 14.525 9.84474C15.5595 7.39161 16.0925 3.74665 14.6494 2.23135C12.8486 0.340048 9.73134 1.85361 8.53246 1.85361Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2050_154)"
    />
  </svg>
);
export default SvgNormal;
